import { setManifest } from '@angular-architects/module-federation';

import { environment } from './environments/environment';

// to parallelize the fetch of version and config, and to avoid nested promises
Promise.all([
  fetch('/assets/version.json').then((res) => res.json()), // Fetch version information
  fetch('/assets/config.json').then((res) => res.json()), // Fetch configuration information
])
  .then(([version, config]) => {
    const storedAppVersion = localStorage.getItem('insights_frontend_app_version');
    if (storedAppVersion && storedAppVersion !== version.version) {
      localStorage.setItem('insights_frontend_app_version', version.version);
      location.reload();
      return;
    }
    localStorage.setItem('insights_frontend_app_version', version.version);

    console.log('██╗███╗   ██╗███████╗██╗ ██████╗ ██╗  ██╗████████╗███████╗');
    console.log('██║████╗  ██║██╔════╝██║██╔════╝ ██║  ██║╚══██╔══╝██╔════╝');
    console.log('██║██╔██╗ ██║███████╗██║██║  ███╗███████║   ██║   ███████╗');
    console.log('██║██║╚██╗██║╚════██║██║██║   ██║██╔══██║   ██║   ╚════██║');
    console.log('██║██║ ╚████║███████║██║╚██████╔╝██║  ██║   ██║   ███████║');
    console.log('╚═╝╚═╝  ╚═══╝╚══════╝╚═╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝');
    console.log(`Version: ${version.version}`);
    console.log(`Build: ${environment.production ? 'Production' : 'Development'}`);

    setManifest(config.remoteApplications)
      .catch((err) => {
        console.error('Error setting manifest:', err);
      })
      .then(() => {
        import('./bootstrap').then((f) => f.bootstrap(config, version));
      });
  })
  .catch((err) => {
    console.error('Error fetching version or config:', err);
  });
